import React from "react";
import { Link } from "react-router-dom";
import PageShell from "../PageShell";
import { Reveal, Counter } from "../UIKit";

const stats = [
  { value: 5.8, display: <>{"$"}<Counter to={5.8} decimals={1} suffix="B" /></>, label: "projected global market size by 2034, up from $2.1B in 2025" },
  { value: 11.9, display: <Counter to={11.9} decimals={1} suffix="%" />, label: "projected CAGR through 2034" },
  { value: 38, display: <Counter to={38} decimals={0} suffix="%" />, label: "of global category revenue comes from Asia-Pacific alone" },
  { value: 0.15, display: <>{"$"}<Counter to={0.15} decimals={2} suffix="B" /></>, label: "India's own market size in 2026 — concentrated in three metros" },
];

export default function MarketPage({ onAuthClick }) {
  return (
    <PageShell
      onAuthClick={onAuthClick}
      eyebrow="The market"
      title="A large, fast-growing market."
      lede="Housing societies across India are adopting management apps quickly — and most of the country is still untapped."
      sceneMode="bars"
      sceneData={stats.map((s) => s.value)}
      seoTitle="Market — Bellboy Security & Society Management App"
      seoDescription="The society management app market: global size, CAGR, regional share, and India's still-untapped Tier-2/3 opportunity."
    >
      <section className="page-section">
        <div className="stat-grid">
          {stats.map((s, i) => (
            <Reveal key={s.label} delay={i * 90} className="stat-card">
              <div className="stat-num">{s.display}</div>
              <div className="stat-label">{s.label}</div>
            </Reveal>
          ))}
        </div>
        <Reveal delay={120} className="market-note">
          Tier-2 and Tier-3 cities are where new townships are being built fastest — and where today's apps
          have barely arrived.
        </Reveal>
        <Reveal delay={160}>
          <Link to="/approach" className="section-btn">See how we get in →</Link>
        </Reveal>
      </section>
    </PageShell>
  );
}
